import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AttendanceRefreshService {
    private readonly refreshAttendance = new Subject<void>();

    refreshAttendance$ = this.refreshAttendance.asObservable();

    triggerRefresh() {
        this.refreshAttendance.next();
    }
}